module.exports = __webpack_public_path__ + "static/img/modernWeb19.1894f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/modernWeb19.jpg
// module id = pstF
// module chunks = 1